(function () {

  // ── Only the COLOR option should drive the gallery (size must not swap images) ──
  var lastColorValue = null;
  function getColorOptionIndex() {
    var fs = document.querySelector("variant-radios fieldset.product-form__controls--colors, .product-form__controls--colors");
    if (!fs) return -1;
    var m = (fs.id || "").match(/SingleOptionSelector-(d+)/);
    return m ? parseInt(m[1], 10) : -1;
  }

  // ── Helpers ──

  function getMetaImages(sectionId, variantId) {
    var container = document.getElementById('variant-meta-images-data-' + sectionId);
    if (!container) return [];
    var variantDiv = container.querySelector('[data-variant-id="' + variantId + '"]');
    if (!variantDiv) return [];
    return Array.from(variantDiv.querySelectorAll('img[data-meta-src]'));
  }

  function buildZoomSrc(src1200) {
    try {
      var u = new URL(src1200, location.href);
      u.searchParams.set('width', '1920');
      return u.toString();
    } catch (e) {
      return src1200.replace(/([?&])width=1200/, '$1width=1920');
    }
  }

  function removeMetaSlides() {
    document.querySelectorAll(
      '.product__media-item--variant-meta, .product__media-subitem--variant-meta'
    ).forEach(function (el) { el.remove(); });
    var popupWrapper = document.querySelector('.js-popup-slider .swiper-wrapper');
    if (popupWrapper) {
      popupWrapper.querySelectorAll('.product__media-item--variant-meta').forEach(function (el) {
        el.remove();
      });
    }
  }

  // Build a set of all variant featured_media_ids from the JSON in the DOM
  function getAllVariantMediaIds(sectionId) {
    var dataEl = document.querySelector('variant-radios [type="application/json"]');
    if (!dataEl) return [];
    try {
      var variants = JSON.parse(dataEl.textContent);
      return variants
        .filter(function (v) { return v.featured_media && v.featured_media.id; })
        .map(function (v) { return String(v.featured_media.id); });
    } catch (e) { return []; }
  }

  // Store detached slides so they can be restored on next filter
  var _detachedMain = [];
  var _detachedSub = [];
  var _detachedPopup = [];

  function _restoreSlides(arr, wrapper) {
    arr.forEach(function (item) {
      if (item.ref && item.ref.parentNode !== wrapper) {
        wrapper.appendChild(item.ref);
      }
    });
    arr.length = 0;
  }

  function _filterWrapper(wrapper, swiper, allVariantMediaIds, activeMediaId, detachedArr, idAttr, hasMetaImages) {
    // Restore previously detached slides
    _restoreSlides(detachedArr, wrapper);

    var toDetach = [];
    Array.from(wrapper.querySelectorAll('.swiper-slide')).forEach(function (slide) {
      var mediaId = slide.getAttribute(idAttr) || slide.getAttribute('data-media-id') || '';

      // Always keep meta slides for current variant
      if (mediaId.indexOf('-meta-') > -1) return;

      // If active variant's featured media — keep
      if (mediaId.indexOf(activeMediaId) > -1) {
        slide.style.display = '';
        return;
      }

      // If product uses metafield images: hide EVERYTHING else
      if (hasMetaImages) {
        toDetach.push(slide);
        return;
      }

      // Fallback for products without metafield images: original logic
      var belongsToAVariant = allVariantMediaIds.some(function (id) {
        return mediaId.indexOf(id) > -1;
      });
      var hasVariantClass = slide.classList.contains('product__media-item--variant');
      if (!belongsToAVariant && !hasVariantClass) return; // lifestyle shot — keep
      toDetach.push(slide);
    });

    // Detach hidden slides instead of display:none
    toDetach.forEach(function (slide) {
      detachedArr.push({ ref: slide });
      wrapper.removeChild(slide);
    });

    if (swiper) {
      swiper.update();
      swiper.slideToClosest(0, false);
    }
  }

  // Filter gallery to only show slides belonging to the active variant
  function filterGallery(sectionId, featuredMediaId) {
    var allVariantMediaIds = getAllVariantMediaIds(sectionId);
    var activeMediaId = String(featuredMediaId);
    var hasMetaImages = !!document.querySelector('#variant-meta-images-data-' + sectionId + ' [data-variant-id]');

    // ── Main slider ──
    var mainSwiperEl = document.querySelector('.js-media-list');
    var swiperWrapper = mainSwiperEl && mainSwiperEl.querySelector('.swiper-wrapper');
    if (swiperWrapper) {
      _filterWrapper(swiperWrapper, mainSwiperEl.swiper, allVariantMediaIds, activeMediaId, _detachedMain, 'data-media-id', hasMetaImages);
    }

    // ── Thumbnail strip ──
    var subSwiperEl = document.querySelector('.js-media-sublist');
    if (subSwiperEl) {
      var subWrapper = subSwiperEl.querySelector('.swiper-wrapper');
      if (subWrapper) {
        _filterWrapper(subWrapper, subSwiperEl.swiper, allVariantMediaIds, activeMediaId, _detachedSub, 'data-media-sub-id', hasMetaImages);
      }
    }

    // ── Popup slider ──
    var popupSwiperEl = document.querySelector('.js-popup-slider');
    if (popupSwiperEl && popupSwiperEl.swiper) {
      var popupWrapper = popupSwiperEl.querySelector('.swiper-wrapper');
      if (popupWrapper) {
        _filterWrapper(popupWrapper, popupSwiperEl.swiper, allVariantMediaIds, activeMediaId, _detachedPopup, 'data-media-modal-id', hasMetaImages);
      }
    }
  }

  function injectMetaImages(sectionId, variantId, featuredMediaId) {
    removeMetaSlides();

    var metaImgs = getMetaImages(sectionId, String(variantId));
    if (metaImgs.length === 0) return;

    // Deduplicate metafield images against existing slides and against each other
    var seenSrcs = new Set();
    Array.from(document.querySelectorAll('.js-media-list .swiper-slide:not(.product__media-item--variant-meta) img')).forEach(function (img) {
      if (img.src) seenSrcs.add(img.src.split('?')[0]);
    });
    metaImgs = metaImgs.filter(function (img) {
      var normalized = img.dataset.metaSrc.replace(/^\/\//, 'https://').split('?')[0];
      if (seenSrcs.has(normalized)) return false;
      seenSrcs.add(normalized);
      return true;
    });
    if (metaImgs.length === 0) return;

    var mainSwiperEl = document.querySelector('.js-media-list');
    var swiperWrapper = mainSwiperEl && mainSwiperEl.querySelector('.swiper-wrapper');
    if (!swiperWrapper) return;

    var anchorMediaId = sectionId + '-' + featuredMediaId;
    var anchorSlide = swiperWrapper.querySelector('[data-media-id="' + anchorMediaId + '"]');
    var insertAfter = anchorSlide || swiperWrapper.querySelector('.swiper-slide-active') || null;

    // ── Main slider ──
    // Get the aspect ratio from existing Liquid-rendered slides to stay consistent
    var existingMedia = swiperWrapper.querySelector('.product__media-item:not(.product__media-item--variant-meta) .product__media');
    var existingPb = existingMedia ? existingMedia.style.paddingBottom : '133.33%';

    metaImgs.forEach(function (img, i) {
      var src     = img.dataset.metaSrc.replace(/^\/\//, 'https://');
      var srcset  = img.dataset.metaSrcset.replace(/^\/\//gm, 'https://');
      var alt     = img.dataset.metaAlt;
      var mediaId = sectionId + '-meta-' + variantId + '-' + i;

      var slide = document.createElement('div');
      slide.className = 'product__media-item swiper-slide product__media-item--variant product__media-item--variant-meta product__media-item--contain';
      slide.setAttribute('data-media-id', mediaId);
      slide.style.cursor = 'pointer';
      slide.innerHTML =
        '<div class="product__media media" style="padding-bottom:' + existingPb + '">' +
          '<img src="' + src + '" srcset="' + srcset + '"' +
               ' sizes="(min-width:1150px) calc((100vw - 10rem) / 2), (min-width:750px) calc((100vw - 10rem) / 2), calc(100vw - 4rem)"' +
               ' alt="' + alt + '" loading="eager"' +
               ' style="object-position:50% 50%;">' +
        '</div>';

      if (insertAfter && insertAfter.nextSibling) {
        swiperWrapper.insertBefore(slide, insertAfter.nextSibling);
      } else {
        swiperWrapper.appendChild(slide);
      }
      insertAfter = slide;
    });

    if (mainSwiperEl.swiper) {
      mainSwiperEl.swiper.update();
      mainSwiperEl.swiper.slideToClosest(0, false);
    }

    // ── Thumbnail strip ──
    var subSwiperEl = document.querySelector('.js-media-sublist');
    if (subSwiperEl && subSwiperEl.swiper) {
      var subWrapper = subSwiperEl.querySelector('.swiper-wrapper');
      var anchorThumb = subWrapper.querySelector('[data-media-sub-id="' + anchorMediaId + '"]');
      var subInsertAfter = anchorThumb || subWrapper.querySelector('.swiper-slide-thumb-active') || null;

      metaImgs.forEach(function (img, i) {
        var src     = img.dataset.metaSrc.replace(/^\/\//, 'https://');
        var alt     = img.dataset.metaAlt;
        var mediaId = sectionId + '-meta-' + variantId + '-' + i;

        var thumb = document.createElement('div');
        thumb.className = 'product__media-subitem swiper-slide product__media-item--variant product__media-subitem--variant-meta';
        thumb.setAttribute('data-media-sub-id', mediaId);
        thumb.innerHTML =
          '<div class="product__media">' +
            '<img src="' + src + '" alt="' + alt + '" loading="eager">' +
          '</div>';

        thumb.addEventListener('click', function () {
          if (!mainSwiperEl.swiper) return;
          var targetSlide = mainSwiperEl.querySelector('[data-media-id="' + mediaId + '"]');
          var idx = Array.from(mainSwiperEl.swiper.slides).indexOf(targetSlide);
          if (idx > -1) mainSwiperEl.swiper.slideTo(idx);
        });

        if (subInsertAfter && subInsertAfter.nextSibling) {
          subWrapper.insertBefore(thumb, subInsertAfter.nextSibling);
        } else {
          subWrapper.appendChild(thumb);
        }
        subInsertAfter = thumb;
      });

      subSwiperEl.swiper.update();
    }

    // ── Popup slider ──
    var popupSwiperEl = document.querySelector('.js-popup-slider');
    if (popupSwiperEl && popupSwiperEl.swiper) {
      var popupWrapper = popupSwiperEl.querySelector('.swiper-wrapper');
      var popupAnchor  = popupWrapper.querySelector('[data-media-id="' + anchorMediaId + '"]');
      var popupInsertAfter = popupAnchor || null;

      metaImgs.forEach(function (img, i) {
        var src     = img.dataset.metaSrc.replace(/^\/\//, 'https://');
        var srcset  = img.dataset.metaSrcset.replace(/^\/\//gm, 'https://');
        var alt     = img.dataset.metaAlt;
        var w       = parseInt(img.dataset.metaWidth)  || 0;
        var h       = parseInt(img.dataset.metaHeight) || 0;
        var pb      = (w && h) ? (h / w * 100).toFixed(2) : '100.00';
        var mediaId = sectionId + '-meta-' + variantId + '-' + i;

        var zoomSrc = buildZoomSrc(src);
        var zoomSrcset = srcset + ', ' + zoomSrc + ' 1920w';
        var popupSlide = document.createElement('div');
        popupSlide.className = 'swiper-slide product-media-modal__item product-media-modal__item--contain product__media-item--variant product__media-item--variant-meta';
        popupSlide.setAttribute('data-media-id', mediaId);
        popupSlide.innerHTML =
          '<div class="swiper-zoom-container">' +
            '<img src="' + zoomSrc + '" srcset="' + zoomSrcset + '"' +
                 ' sizes="(min-width:990px) 80vw,100vw"' +
                 ' alt="' + alt + '" loading="eager">' +
          '</div>';

        if (popupInsertAfter && popupInsertAfter.nextSibling) {
          popupWrapper.insertBefore(popupSlide, popupInsertAfter.nextSibling);
        } else {
          popupWrapper.appendChild(popupSlide);
        }
        popupInsertAfter = popupSlide;
      });

      popupSwiperEl.swiper.update();
    }
  }

  // ════════════════════════════════════════════════════════════════════════
  // VARIANT GRID layout (gallery_type: variant_grid) — non-swiper grid path.
  // Guarded by .product__outer--variant-grid so slider/grid galleries are
  // completely untouched. Shows ONLY the active variant's images
  // (native featured_media + custom.variant_images metafield images).
  // ════════════════════════════════════════════════════════════════════════

  function isVariantGrid() {
    return !!document.querySelector('.product__outer--variant-grid');
  }

  function getGridList() {
    var outer = document.querySelector('.product__outer--variant-grid');
    if (!outer) return null;
    // The live (no-js-hidden) media list, not the .product__media-grid-noscript fallback
    return outer.querySelector('.product__media-list.no-js-hidden');
  }

  // Inject popup (fullscreen) slides for the variant's metafield images
  function injectMetaPopupSlides(sectionId, variantId, metaImgs) {
    var popupSwiperEl = document.querySelector('.js-popup-slider');
    if (!popupSwiperEl || !popupSwiperEl.swiper) return;
    var popupWrapper = popupSwiperEl.querySelector('.swiper-wrapper');
    if (!popupWrapper) return;

    metaImgs.forEach(function (img, i) {
      var src     = img.dataset.metaSrc.replace(/^\/\//, 'https://');
      var srcset  = img.dataset.metaSrcset.replace(/^\/\//gm, 'https://');
      var alt     = img.dataset.metaAlt;
      var mediaId = sectionId + '-meta-' + variantId + '-' + i;
      var zoomSrc = buildZoomSrc(src);
      var zoomSrcset = srcset + ', ' + zoomSrc + ' 1920w';

      var popupSlide = document.createElement('div');
      popupSlide.className = 'swiper-slide product-media-modal__item product-media-modal__item--contain product__media-item--variant product__media-item--variant-meta';
      popupSlide.setAttribute('data-media-modal-id', mediaId);
      popupSlide.innerHTML =
        '<div class="swiper-zoom-container">' +
          '<img src="' + zoomSrc + '" srcset="' + zoomSrcset + '"' +
               ' sizes="(min-width:990px) 80vw,100vw"' +
               ' alt="' + alt + '" loading="eager">' +
        '</div>';
      popupWrapper.appendChild(popupSlide);
    });
    popupSwiperEl.swiper.update();
  }

  // Show only the active variant's native featured cell; hide all other native cells
  function gridFilterNative(list, sectionId, featuredMediaId) {
    var activeAnchorId = sectionId + '-' + featuredMediaId;
    var shown = 0;
    list.querySelectorAll('.product__media-item:not(.product__media-item--variant-meta)').forEach(function (el) {
      var mediaId = el.getAttribute('data-media-id') || '';
      if (featuredMediaId && mediaId === activeAnchorId) {
        el.style.display = '';
        el.removeAttribute('data-variant-hidden');
        shown++;
      } else {
        el.style.display = 'none';
        el.setAttribute('data-variant-hidden', '');
      }
    });
    // Safety: nothing matched (e.g. variant has no featured_media) — keep server .active
    if (shown === 0) {
      var activeEl = list.querySelector('.product__media-item.active:not(.product__media-item--variant-meta)');
      if (activeEl) {
        activeEl.style.display = '';
        activeEl.removeAttribute('data-variant-hidden');
        shown = 1;
      }
    }
    return shown;
  }

  // Inject the active variant's metafield images as equal grid cells (+ popup slides)
  function gridInjectMeta(list, sectionId, variantId, featuredMediaId) {
    var metaImgs = getMetaImages(sectionId, String(variantId));
    if (metaImgs.length === 0) return 0;

    // Dedup against currently-visible native images (esp. the active featured)
    var seen = new Set();
    list.querySelectorAll('.product__media-item:not([data-variant-hidden]):not(.product__media-item--variant-meta) img').forEach(function (img) {
      var s = (img.currentSrc || img.src || '').split('?')[0];
      if (s) seen.add(s);
    });
    metaImgs = metaImgs.filter(function (img) {
      var n = img.dataset.metaSrc.replace(/^\/\//, 'https://').split('?')[0];
      if (seen.has(n)) return false;
      seen.add(n);
      return true;
    });
    if (metaImgs.length === 0) return 0;

    // Match aspect ratio to an existing visible native cell for equal heights
    var nativeMedia = list.querySelector('.product__media-item:not([data-variant-hidden]):not(.product__media-item--variant-meta) .product__media');
    var basePb = nativeMedia && nativeMedia.style.paddingBottom ? nativeMedia.style.paddingBottom : '';
    var sizes = '(min-width: 1150px) calc((100vw - 10rem) / 2), (min-width: 750px) calc((100vw - 10rem) / 2), calc(100vw - 4rem)';

    metaImgs.forEach(function (img, i) {
      var src     = img.dataset.metaSrc.replace(/^\/\//, 'https://');
      var srcset  = img.dataset.metaSrcset.replace(/^\/\//gm, 'https://');
      var alt     = img.dataset.metaAlt;
      var mediaId = sectionId + '-meta-' + variantId + '-' + i;
      var w = parseInt(img.dataset.metaWidth, 10);
      var h = parseInt(img.dataset.metaHeight, 10);
      var pb = basePb || ((w && h) ? (h / w * 100).toFixed(2) + '%' : '133.33%');

      var cell = document.createElement('div');
      cell.className = 'product__media-item swiper-slide product__media-item--variant product__media-item--variant-meta product__media-item--contain';
      cell.setAttribute('data-media-id', mediaId);
      cell.innerHTML =
        '<modal-opener class="product__modal-opener product__modal-opener--image no-js-hidden" data-modal="#ProductModal-' + sectionId + '">' +
          '<span class="product__media-icon motion-reduce" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M11 4a7 7 0 1 0 4.2 12.6l4.1 4.1 1.4-1.4-4.1-4.1A7 7 0 0 0 11 4Zm-5 7a5 5 0 1 1 10 0 5 5 0 0 1-10 0Zm4-3h2v2h2v2h-2v2h-2v-2H8v-2h2V8Z" fill="currentColor"/></svg>' +
          '</span>' +
          '<div class="product__media media" style="padding-bottom:' + pb + '">' +
            '<img src="' + src + '" srcset="' + srcset + '" sizes="' + sizes + '" alt="' + alt + '" loading="eager" style="object-position:50% 50%;">' +
          '</div>' +
          '<button class="product__media-toggle focus-inset" type="button" aria-haspopup="dialog" data-media-id="meta-' + variantId + '-' + i + '"></button>' +
        '</modal-opener>';
      list.appendChild(cell);
    });

    injectMetaPopupSlides(sectionId, variantId, metaImgs);
    return metaImgs.length;
  }

  // Layout by visible image count:
  //   1-2 → single full-width column (1 image, or 2 equal stacked rows)
  //   3+  → first image big (full width), remaining images in a 2-column grid below
  function gridApplyLayout(list, visibleCount) {
    list.classList.toggle('product__media-list--full', visibleCount <= 2);
    list.querySelectorAll('.product__media-item--vg-big').forEach(function (el) {
      el.classList.remove('product__media-item--vg-big');
    });
    if (visibleCount >= 3) {
      var firstVisible = list.querySelector('.product__media-item:not([data-variant-hidden])');
      if (firstVisible) firstVisible.classList.add('product__media-item--vg-big');
    }
  }

  // Re-bind each visible grid cell's modal toggle to the correct popup slide index.
  // The global.js positional binding goes stale once we hide/inject cells, so map
  // by media id (robust to hidden natives) rather than DOM position.
  function gridRebindModalOpeners(sectionId, list) {
    var popup = document.querySelector('.js-popup-slider');
    if (!list || !popup || !popup.swiper) return;

    var indexById = {};
    popup.swiper.slides.forEach(function (slide, idx) {
      var id = slide.getAttribute('data-media-modal-id') || slide.getAttribute('data-media-id') || '';
      if (id && !(id in indexById)) indexById[id] = idx;
    });

    list.querySelectorAll('.product__media-item:not([data-variant-hidden])').forEach(function (cell) {
      var cellId = cell.getAttribute('data-media-id') || '';
      var btn = cell.querySelector('.product__media-toggle');
      if (!btn) return;
      var idx = indexById[cellId];
      if (typeof idx !== 'number') return;
      if (btn._gridModalHandler) btn.removeEventListener('click', btn._gridModalHandler);
      btn._gridModalHandler = function () {
        if (popup.swiper) popup.swiper.slideTo(idx, 0);
      };
      btn.addEventListener('click', btn._gridModalHandler);
    });
  }

  // Full variant-grid refresh (filter natives + inject metas + sizing + modal binding)
  function runVariantGrid(sectionId, variantId, featuredMediaId) {
    var list = getGridList();
    if (!list) return;
    removeMetaSlides();
    var shown = gridFilterNative(list, sectionId, featuredMediaId);
    var metaCount = gridInjectMeta(list, sectionId, variantId, featuredMediaId);
    gridApplyLayout(list, shown + metaCount);
    list.setAttribute('data-grid-ready', '');
    // Fullscreen modal: filter its slider to the active variant's images. The main
    // grid + thumb-strip selectors are absent in this layout, so filterGallery only
    // affects the popup slider here.
    filterGallery(sectionId, featuredMediaId);
    gridRebindModalOpeners(sectionId, list);
    // Rebuild modal thumbnail swatches from the now-filtered popup slider
    variantGallery.rebuild();
    variantGallery.buildModalThumbs();
  }

  // ── Toggle thumbnail strip based on variant's total usable image count ──
  function toggleThumbStrip(sectionId, variantId, hasFeaturedMedia) {
    var outer = document.querySelector('.product__media-sublist-outer');
    if (!outer) return;

    // Count from data, not DOM:
    // 1 for featured image (if present) + number of custom.variant_images
    var imageCount = hasFeaturedMedia ? 1 : 0;
    var metaImgs = getMetaImages(sectionId, String(variantId));
    imageCount += metaImgs.length;

    outer.style.display = imageCount <= 1 ? 'none' : '';
  }

  // ── Variant Gallery State (single source of truth) ──

  var variantGallery = {
    items: [],
    activeIndex: 0,
    _syncing: false,
    _popupSyncAttached: false,
    _zoomAttached: false,
    ZOOM_MIN: 1,
    ZOOM_MAX: 3,
    ZOOM_STEP: 0.5,

    rebuild: function () {
      // Variant grid has no .js-media-list — derive items from the filtered popup slider
      if (document.querySelector('.product__outer--variant-grid')) {
        var popupEl = document.querySelector('.js-popup-slider');
        if (!popupEl || !popupEl.swiper) { this.items = []; return; }
        var pslides = Array.from(popupEl.swiper.slides).filter(function (s) {
          return !s.classList.contains('swiper-slide-duplicate');
        });
        this.items = pslides.map(function (slide) {
          var img = slide.querySelector('img');
          return {
            src: img ? img.getAttribute('src') || '' : '',
            alt: img ? (img.alt || '') : ''
          };
        });
        this.activeIndex = Math.min(popupEl.swiper.activeIndex || 0, Math.max(0, this.items.length - 1));
        return;
      }
      var mainSwiperEl = document.querySelector('.js-media-list');
      if (!mainSwiperEl || !mainSwiperEl.swiper) { this.items = []; return; }
      this.items = Array.from(mainSwiperEl.swiper.slides).map(function (slide) {
        var img = slide.querySelector('img');
        return {
          src: img ? img.getAttribute('src') || '' : '',
          alt: img ? (img.alt || '') : ''
        };
      });
      this.activeIndex = Math.min(
        mainSwiperEl.swiper.activeIndex || 0,
        Math.max(0, this.items.length - 1)
      );
    },

    buildModalThumbs: function () {
      var outer = document.querySelector('.js-popup-thumbs-outer');
      var thumbsEl = document.querySelector('.js-popup-thumbs');
      var modal = document.querySelector('product-modal');
      if (!outer || !thumbsEl) return;

      if (this.items.length <= 1) {
        outer.classList.remove('is-active');
        if (modal) modal.classList.remove('has-modal-thumbs');
        return;
      }
      outer.classList.add('is-active');
      if (modal) modal.classList.add('has-modal-thumbs');

      thumbsEl.innerHTML = '';
      var self = this;
      this.items.forEach(function (item, i) {
        var thumb = document.createElement('div');
        thumb.className = 'product-media-modal__thumb' +
          (i === self.activeIndex ? ' is-active' : '');
        var thumbSrc = item.src.replace(/width=\d+/, 'width=200');
        thumb.innerHTML = '<img src="' + thumbSrc + '" alt="' +
          (item.alt || '').replace(/"/g, '&quot;') + '" loading="eager">';
        thumb.addEventListener('click', function () {
          var popupEl = document.querySelector('.js-popup-slider');
          if (popupEl && popupEl.swiper) popupEl.swiper.slideTo(i);
        });
        thumbsEl.appendChild(thumb);
      });
    },

    syncModalThumb: function (idx) {
      this.activeIndex = idx;
      var thumbsEl = document.querySelector('.js-popup-thumbs');
      if (!thumbsEl) return;
      var allThumbs = thumbsEl.querySelectorAll('.product-media-modal__thumb');
      allThumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === idx);
      });
      if (allThumbs[idx]) {
        allThumbs[idx].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    },

    attachPopupSync: function () {
      if (this._popupSyncAttached) return;
      var popupEl = document.querySelector('.js-popup-slider');
      if (!popupEl || !popupEl.swiper) return;
      this._popupSyncAttached = true;
      var self = this;
      popupEl.swiper.on('slideChange', function () {
        if (self._syncing) return;
        self._syncing = true;
        var idx = this.activeIndex;
        self.syncModalThumb(idx);
        self.resetZoom();
        // Sync main page slider
        var mainEl = document.querySelector('.js-media-list');
        if (mainEl && mainEl.swiper && mainEl.swiper.activeIndex !== idx) {
          mainEl.swiper.slideTo(idx);
        }
        self._syncing = false;
      });
    },

    resetZoom: function () {
      var popupEl = document.querySelector('.js-popup-slider');
      if (popupEl && popupEl.swiper && popupEl.swiper.zoom) {
        popupEl.swiper.zoom.out();
      }
    },

    attachZoomControls: function () {
      if (this._zoomAttached) return;
      var zoomInBtn = document.querySelector('.js-popup-zoom-in');
      var zoomOutBtn = document.querySelector('.js-popup-zoom-out');
      if (!zoomInBtn || !zoomOutBtn) return;
      this._zoomAttached = true;
      var self = this;

      zoomInBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var popupEl = document.querySelector('.js-popup-slider');
        if (!popupEl || !popupEl.swiper || !popupEl.swiper.zoom) return;
        var current = popupEl.swiper.zoom.scale || 1;
        var next = Math.min(current + self.ZOOM_STEP, self.ZOOM_MAX);
        if (next !== current) popupEl.swiper.zoom.in(next);
      });

      zoomOutBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var popupEl = document.querySelector('.js-popup-slider');
        if (!popupEl || !popupEl.swiper || !popupEl.swiper.zoom) return;
        var current = popupEl.swiper.zoom.scale || 1;
        var next = Math.max(current - self.ZOOM_STEP, self.ZOOM_MIN);
        if (next !== current) {
          if (next <= 1) popupEl.swiper.zoom.out();
          else popupEl.swiper.zoom.in(next);
        }
      });
    },

    onModalOpen: function () {
      this.rebuild();
      this.buildModalThumbs();
      this.attachPopupSync();
      this.attachZoomControls();
      this.resetZoom();
    }
  };

  window.variantGallery = variantGallery;

  // ── Event listeners ──

  document.addEventListener('variant:change', function (event) {
    var variant   = event.detail && event.detail.variant;
    var sectionId = event.detail && event.detail.sectionId;
    if (!variant || !sectionId) return;

    // Only a COLOR change should swap the gallery — ignore size and other non-color options
    var _colorIdx = getColorOptionIndex();
    var _newColor = (_colorIdx > -1 && variant.options) ? variant.options[_colorIdx] : null;
    if (_colorIdx > -1 && _newColor !== null && _newColor === lastColorValue) {
      return;
    }
    lastColorValue = _newColor;

    var modal = document.querySelector('product-modal');
    if (modal && modal.getAttribute('aria-hidden') !== 'true') {
      modal.hide();
    }

    var featuredMediaId = variant.featured_media && variant.featured_media.id;

    removeMetaSlides();

    setTimeout(function () {
      // Variant grid layout: dedicated non-swiper path, then bail out
      if (isVariantGrid()) {
        runVariantGrid(sectionId, variant.id, featuredMediaId);
        return;
      }

      // Ensure thumb strip is visible before filtering so Swiper can measure
      var outerEl = document.querySelector('.product__media-sublist-outer');
      if (outerEl) outerEl.style.display = '';

      filterGallery(sectionId, featuredMediaId);
      injectMetaImages(sectionId, variant.id, featuredMediaId);
      toggleThumbStrip(sectionId, variant.id, !!featuredMediaId);
      // Rebuild gallery state after slides are updated
      variantGallery.rebuild();
      variantGallery.buildModalThumbs();
    }, 0);
  });

  // ── Page load ──
  document.addEventListener('DOMContentLoaded', function () {

    // Delegated click listener: opens fullscreen for metafield slides.
    // Native slides are handled by their modal-opener elements; this catches everything else.
    var mainGalleryEl = document.querySelector('.js-media-list');
    var productModal = document.querySelector('product-modal');
    if (mainGalleryEl && productModal) {
      mainGalleryEl.addEventListener('click', function (e) {
        if (e.target.closest('modal-opener')) return;
        var ms = mainGalleryEl.swiper;
        if (ms) productModal.show(e.target);
      });
    }

    // Section id: from variant-radios, or — for a single-variant variant_grid
    // product that has no variant picker — from the variant-grid section wrapper.
    var variantRadiosEl = document.querySelector('variant-radios[data-section]');
    var sectionId = variantRadiosEl ? variantRadiosEl.getAttribute('data-section') : null;
    if (!sectionId && isVariantGrid()) {
      var vgOuter = document.querySelector('.product__outer--variant-grid');
      var vgSection = vgOuter && vgOuter.closest('[data-section]');
      sectionId = vgSection ? vgSection.getAttribute('data-section') : null;
    }
    if (!sectionId) return;

    var variantId = new URLSearchParams(window.location.search).get('variant');
    var featuredMediaId = null;

    var dataEl = document.querySelector('variant-radios [type="application/json"]');
    if (dataEl) {
      try {
        var variants = JSON.parse(dataEl.textContent);
        var found = null;

        // 1. URL param — most explicit
        if (variantId) {
          found = variants.find(function (v) { return String(v.id) === variantId; });
        }

        // 2. Server-rendered form hidden input — ground truth for the default variant
        if (!found) {
          var formInput = document.querySelector('#product-form-' + sectionId + ' input[name="id"]');
          if (formInput && formInput.value) {
            found = variants.find(function (v) { return String(v.id) === formInput.value; });
          }
        }

        // 3. All checked radios matched against ALL options — last resort
        if (!found) {
          var allChecked = Array.from(document.querySelectorAll('variant-radios input:checked'));
          var selectedVals = allChecked.map(function (r) { return r.value; });
          if (selectedVals.length) {
            found = variants.find(function (v) {
              return selectedVals.every(function (opt) { return v.options.indexOf(opt) > -1; });
            });
          }
        }

        if (found) {
          variantId       = String(found.id);
          featuredMediaId = found.featured_media && found.featured_media.id;
          var _ci = getColorOptionIndex();
          if (_ci > -1 && found.options) lastColorValue = found.options[_ci];
        }
      } catch (e) {}
    }

    // Fallbacks for single-variant products (no variant-radios JSON): variant id
    // from the product form, featured media id from the server-rendered .active item.
    if (!variantId) {
      var formInputVG = document.querySelector('#product-form-' + sectionId + ' input[name="id"]');
      if (formInputVG && formInputVG.value) variantId = formInputVG.value;
    }
    if (!featuredMediaId) {
      var activeItemVG = document.querySelector('.product__media-item.active[data-media-id^="' + sectionId + '-"]');
      if (activeItemVG) {
        featuredMediaId = (activeItemVG.getAttribute('data-media-id') || '').slice((sectionId + '-').length);
      }
    }

    // Variant grid layout: runs with or without a variant picker. Filter immediately
    // (no swiper to wait for), then finalize popup slides + modal bindings once ready.
    if (isVariantGrid()) {
      var gridList = getGridList();
      if (gridList) {
        removeMetaSlides();
        var shownN = gridFilterNative(gridList, sectionId, featuredMediaId);
        var metaN = variantId ? gridInjectMeta(gridList, sectionId, variantId, featuredMediaId) : 0;
        gridApplyLayout(gridList, shownN + metaN);
        gridList.setAttribute('data-grid-ready', '');
      }
      var gpoll = setInterval(function () {
        var popupEl = document.querySelector('.js-popup-slider');
        if (!popupEl || !popupEl.swiper) return;
        clearInterval(gpoll);
        runVariantGrid(sectionId, variantId, featuredMediaId);
      }, 50);
      return;
    }

    if (!variantId) return;

    var poll = setInterval(function () {
      var mainSwiperEl = document.querySelector('.js-media-list');
      if (!mainSwiperEl || !mainSwiperEl.swiper) return;
      clearInterval(poll);
      filterGallery(sectionId, featuredMediaId);
      injectMetaImages(sectionId, variantId, featuredMediaId);
      toggleThumbStrip(sectionId, variantId, !!featuredMediaId);
      // Initialize gallery state after page-load filtering
      variantGallery.rebuild();
    }, 50);
  });

})();